import { unwrapResult } from '@reduxjs/toolkit'
import { Route } from '../../../config/router'
import { Checkout, CrossRegionRedirection } from '../../../model'
import { getCheckout, crossRegionUserSignIn } from '../../../state'
import { Country } from '@afterpaytouch/portal-api/types'
import { CHECKOUT_FLOW_TYPE, postCheckoutFlowMessage } from '../../../integrations/inappbrowser-messenger'
import { validateCheckoutStatus, validateMerchantCountry } from '../validation'

export interface CheckoutFetchRequest {
  country: Country
  skipPrefill: boolean
}

export interface CheckoutResult {
  checkout: Checkout
}

export const fetchAndValidateCheckout = async (
  request: CheckoutFetchRequest,
  dispatch: (action: any) => any
): Promise<CheckoutResult | CrossRegionRedirection | { route: Route }> => {
  const checkoutResponse = await dispatch(getCheckout())
  const checkout = unwrapResult(checkoutResponse)

  /* Post message on checkout loaded to Afterpay React Native App WebView */
  postCheckoutFlowMessage(CHECKOUT_FLOW_TYPE.ON_CHECKOUT_LOADED)

  // Validate checkout status
  if (validateCheckoutStatus(checkout)) {
    return { route: Route.TERMINAL_ERROR }
  }

  // Validate merchant country
  if (validateMerchantCountry(checkout, request.country)) {
    const newCountry = checkout.merchant.supportedCountries[0]
    const email = checkout.consumer?.email ?? ''
    return unwrapResult(
      await dispatch(
        crossRegionUserSignIn({
          consumerEmail: email === '' ? '-' : email, // hack: backend chokes on blank emails
          consumerCountryCode: newCountry,
          consumerMobile: checkout.consumer?.phoneNumber ?? '',
        })
      )
    )
  }

  if (request.skipPrefill) {
    return { route: Route.ENTER_EMAIL }
  }

  return { checkout }
}
